export enum SeasonalDecorationEmoji {
  HALLOWEEN = '🎃',
  CHRISTMAS = '🎄',
}